import React from 'react'
import { useNavigate } from 'react-router'
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa'

function App() {
  const navigate = useNavigate()

  return (
    <footer className="site-footer p-5">
      <div>
        <div
          className="row"
          style={{ justifyContent: 'space-between', width: '100%' }}
        >
          <div className="col-12 col-md-4 col-lg-3">
            <h6 className="follow-us">Navigation</h6>
            <ul className="footer-links">
              <li>
                <a href="http://swara.video">Home</a>
              </li>
              <li>
                <a
                  target="_blank"
                  onClick={() => navigate('/about-us')}
                  className="footer-item"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  onClick={() => navigate('/download')}
                  className="footer-item"
                >
                  Download App
                </a>
              </li>
            </ul>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <h6>LEGAL</h6>
            <ul className="footer-links">
              <li>
                <a
                  target="_blank"
                  onClick={() => navigate('/privacy-policy')}
                  className="footer-item"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          <div className="col-12 col-md-4 col-lg-3">
            <h6>TALK TO US</h6>
            <ul className="footer-links">
              <li>
                <a
                  target="_blank"
                  href="mailto:hello@swara.media"
                  className="email-link"
                >
                  hello@swara.media
                </a>
              </li>
              <li>
                <a target="_blank" href="tel:+19876547865">
                  +1- (530) 444 - 9125
                </a>
              </li>
            </ul>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <h6 style={{ marginLeft: '1rem' }}>FOLLOW US</h6>
            <div className="social-icons-container">
              <a
                target="_blank"
                href="https://www.facebook.com/TheSwaraMedia/"
                className="social-link"
                aria-label="Facebook"
              >
                {FaFacebook({ className: 'social-icon facebook-icon' })}
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/TheSwaraMedia/"
                className="social-link"
                aria-label="Instagram"
              >
                {FaInstagram({ className: 'social-icon instagram-icon' })}
              </a>
              <a
                target="_blank"
                href="https://www.linkedin.com/company/theswaramedia/"
                className="social-link"
                aria-label="LinkedIn"
              >
                {FaLinkedin({ className: 'social-icon linkedin-icon' })}
              </a>
              <a
                target="_blank"
                href="https://twitter.com/TheSwaraMedia"
                className="social-link"
                aria-label="Twitter"
              >
                {FaTwitter({ className: 'social-icon twitter-icon' })}
              </a>
            </div>
          </div>
          <div className="col-12 col-md-4 col-lg-3">
            <div className="app-icons">
              <a
                target="_blank"
                href="https://apps.apple.com/us/app/swara-media/id1472045249"
              >
                <img
                  className="apple"
                  src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1276560000&h=7e7b68fad19738b5649a1bfb78ff46e9"
                  alt="Download on the App Store"
                />
              </a>
              <a
                target="_blank"
                href="https://play.google.com/store/apps/details?id=com.theswara.androidapp"
              >
                <img
                  className="android"
                  alt="Get it on Google Play"
                  src="https://robu.in/wp-content/uploads/2013/01/Google-Play-Badge.png"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-container">
        <p className="copyright-text">
          Copyright &copy; {new Date().getFullYear()} All Rights Reserved to
          Aamee Global Inc (DBA: Swara Media & Marketing LLC) and Technology
          Partner Hana E Solutions Inc
        </p>
      </div>
    </footer>
  )
}

export default App
